import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getAllChapterApi,
  createChapterApi,
  updateChapterApi,
  deleteChapterApi,
} from "../../apis/curriculumManagement";

export const getAllChapters = createAsyncThunk("chapters/getAll", async () => {
  const response = await getAllChapterApi();
  return response.data.data;
});

export const createChapter = createAsyncThunk(
  "course/create",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await createChapterApi(formData);
      return response.data?.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to create course"
      );
    }
  }
);

export const updateChapter = createAsyncThunk(
  "chapter/update",
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const response = await updateChapterApi(id, formData);
      return response.data?.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to update course"
      );
    }
  }
);

export const deleteChapter = createAsyncThunk(
  "chapter/delete",
  async (id, { rejectWithValue }) => {
    try {
      await deleteChapterApi(id);
      return id; // Return deleted subject ID to update state
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to delete subject"
      );
    }
  }
);

const chapterSlice = createSlice({
  name: "chapters",
  initialState: {
    chapters: [],
    status: "idle",
    error: null,
  },
  reducers: {
    reset: (state) => {
      state.chapters = [];
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllChapters.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getAllChapters.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.chapters = action.payload;
      })
      .addCase(getAllChapters.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      // create chapter
      .addCase(createChapter.pending, (state) => {
        state.status = "loading";
      })
      .addCase(createChapter.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.chapters.push(action.payload);
      })
      .addCase(createChapter.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Failed to create course.";
      })

      // delete
      .addCase(deleteChapter.pending, (state) => {
        state.status = "loading";
      })
      .addCase(deleteChapter.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.chapters = state.chapters.filter(
          (chapter) => chapter.id !== action.payload
        );
      })
      .addCase(deleteChapter.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Failed to delete  chapter.";
      })

      // update the chapter ---
      .addCase(updateChapter.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updateChapter.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.chapters = state.chapters.map((chapter) =>
          chapter.id === action.payload.id ? action.payload : chapter
        ); // Update the course in state
      })
      .addCase(updateChapter.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Failed to update course.";
      });
  },
});
export default chapterSlice.reducer;
